// Create local App object so it will be minified
var App = {};

// Store local App object globally
window.App = App;